import {useState} from 'react';
import {useTimeout} from '@netx/core-components/hooks/useTimeout';

export type UseActionMenuParams = {
	mainMenuOpen?: boolean;
};

export const useActionMenu = ({mainMenuOpen}: UseActionMenuParams = {}) => {
	const [activeDepth, _setActiveDepth] = useState(-1);

	const {executeTimeout, cancelTimeout} = useTimeout({
		timeout: 200,
	});

	const setActiveDepth = (depth: number) => {
		cancelTimeout();
		_setActiveDepth(depth);
	};

	const handleDepthLeft = (depth: number, delay = 0) => {
		cancelTimeout();
		executeTimeout(() => {
			_setActiveDepth((activeDepth) => {
				return depth === activeDepth
					? Math.max(activeDepth - 1, -1)
					: activeDepth;
			});
		}, delay);
	};

	return {
		activeDepth,
		mainMenuOpen,
		cancelDepthLeft: cancelTimeout,
		setActiveDepth,
		handleDepthLeft,
	};
};
